const NotFound = () => {
  return (
    <div className='flex items-center justify-center bg-gradient-to-br from-[#14315e] to-[#050d1e] text-white px-4 py-32'>
      <div className='text-center'>
        <h1 className='text-6xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-cyan-300 to-sky-400'>404</h1>
        <h2 className='text-2xl text-gray-300'>Страница не найдена</h2>
      </div>
    </div>
  );
};

export default NotFound;
